// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data_with_percentage_container {
  /* flex-wrap: nowrap; */
  padding: 0 1rem;
  background-color: #fff;
}

.data_with_percentage {
  padding: 1rem;
  flex: 1 1;
}

.data_with_percentage .count_container {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.data_with_percentage .count_title {
  font-size: 1.1rem;
  color: gray;
}

.data_with_percentage h2,
h4 {
  margin: 0% !important;
  color: black !important;
}

.data_with_percentage .count_container .success {
  color: #22e222 !important;
}

.data_with_percentage .count_container .danger {
  color: #ff0000 !important;
}

.data_with_percentage .count_dis {
  font-size: 0.8rem;
  color: gray;
}

.home_graphs_sec {
  background-color: #ffffff;
  padding: 1.5rem 0;
}

.home_graphs_container {
  margin: 0% !important;
  display: flex;
  justify-content: space-evenly;
}

.home_graphs_container .responsive_container {
  padding-bottom: 1rem;
}

.home_graphs_container_graph_heading {
  text-align: center;
  font-size: 1.2rem;
  color: gray;
  padding-top: 1rem;
}

.placeholders {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  gap: 1rem;
}

.placeholders .desc {
  height: 12px !important;
  width: 90% !important;
}

.home_filter_sec {
  background-color: #fff;
  padding: 1rem;
  flex-direction: column;
}

.home_filter_sec .ant-form-item {
  margin-bottom: 0%;
}

.home_filter_sec .ant-form-item .ant-row {
  margin: 1rem 0 !important;
}

.pt-0 {
  padding-top: 0% !important;
}

.custom_tooltip {
  background: #fff;
  padding: 0.7rem;
  box-shadow: 0px 0px 3px #778899c7 inset;
}

.custom_tooltip .lable {
  margin-bottom: 0.5rem;
}
.custom_tooltip .value {
  color: #490a2d;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/RedesignHome.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB","sourcesContent":[".data_with_percentage_container {\r\n  /* flex-wrap: nowrap; */\r\n  padding: 0 1rem;\r\n  background-color: #fff;\r\n}\r\n\r\n.data_with_percentage {\r\n  padding: 1rem;\r\n  flex: 1;\r\n}\r\n\r\n.data_with_percentage .count_container {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.data_with_percentage .count_title {\r\n  font-size: 1.1rem;\r\n  color: gray;\r\n}\r\n\r\n.data_with_percentage h2,\r\nh4 {\r\n  margin: 0% !important;\r\n  color: black !important;\r\n}\r\n\r\n.data_with_percentage .count_container .success {\r\n  color: #22e222 !important;\r\n}\r\n\r\n.data_with_percentage .count_container .danger {\r\n  color: #ff0000 !important;\r\n}\r\n\r\n.data_with_percentage .count_dis {\r\n  font-size: 0.8rem;\r\n  color: gray;\r\n}\r\n\r\n.home_graphs_sec {\r\n  background-color: #ffffff;\r\n  padding: 1.5rem 0;\r\n}\r\n\r\n.home_graphs_container {\r\n  margin: 0% !important;\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n}\r\n\r\n.home_graphs_container .responsive_container {\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.home_graphs_container_graph_heading {\r\n  text-align: center;\r\n  font-size: 1.2rem;\r\n  color: gray;\r\n  padding-top: 1rem;\r\n}\r\n\r\n.placeholders {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-self: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.placeholders .desc {\r\n  height: 12px !important;\r\n  width: 90% !important;\r\n}\r\n\r\n.home_filter_sec {\r\n  background-color: #fff;\r\n  padding: 1rem;\r\n  flex-direction: column;\r\n}\r\n\r\n.home_filter_sec .ant-form-item {\r\n  margin-bottom: 0%;\r\n}\r\n\r\n.home_filter_sec .ant-form-item .ant-row {\r\n  margin: 1rem 0 !important;\r\n}\r\n\r\n.pt-0 {\r\n  padding-top: 0% !important;\r\n}\r\n\r\n.custom_tooltip {\r\n  background: #fff;\r\n  padding: 0.7rem;\r\n  box-shadow: 0px 0px 3px #778899c7 inset;\r\n}\r\n\r\n.custom_tooltip .lable {\r\n  margin-bottom: 0.5rem;\r\n}\r\n.custom_tooltip .value {\r\n  color: #490a2d;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
